import type { LayoutBlock } from '@web-studio/shared-schemas';
import {
  sushiAllergyForm,
  sushiChefStory,
  sushiDynamicMenu,
  sushiFooter,
  sushiHeroEditorial,
  sushiHeroVideo,
  sushiMenuGrid,
  sushiNavigationHeader,
  sushiReservationForm,
  sushiTastingTimeline,
} from '../blocks/sushiBar';

/** Restaurant / plus — full sushi stack (all Premium Experience blocks). */
export const sushiBarPlusPage: LayoutBlock[] = [
  { ...sushiNavigationHeader, displayOrder: 0 },
  { ...sushiHeroEditorial, displayOrder: 1 },
  { ...sushiMenuGrid, displayOrder: 2 },
  { ...sushiDynamicMenu, displayOrder: 3 },
  { ...sushiReservationForm, displayOrder: 4 },
  { ...sushiChefStory, displayOrder: 5 },
  { ...sushiTastingTimeline, displayOrder: 6 },
  { ...sushiAllergyForm, displayOrder: 7 },
  { ...sushiHeroVideo, displayOrder: 8 },
  { ...sushiFooter, displayOrder: 9 },
];
